export default "__VITE_ASSET__818758ff__"